import React from "react";
import { Redirect } from "react-router-dom";
const Dashboard = React.lazy(() => import("./components/dashboard/Dashboard"));
const FlujoCaja = React.lazy(() => import("./components/flujocaja/FlujoCaja"));
const Creditos = React.lazy(() => import("./components/creditos/Creditos"));
const DocumentosTributarios = React.lazy(() =>
  import("./components/documentostributarios/DocumentosTributarios")
);
const Proveedores = React.lazy(() =>
  import("./components/proveedores/Proveedores")
);
const Agenda = React.lazy(() => import("./components/agenda/Agenda"));
const Conexiones = React.lazy(() =>
  import("./components/conexiones/Conexiones")
);
const Reportes = React.lazy(() => import("./components/reportes/Reportes"));
const ReportesDJ = React.lazy(() => import("./components/reportes/ReportesDJ"));
const Eerr = React.lazy(() => import("./components/EERR(new)"));
// const Conciliacion = React.lazy(() =>
//   import("./components/conciliacion/Conciliacion")
// );
const Conciliacion2 = React.lazy(() =>
  import("./components/transactions(new)")
);
const Usuarios = React.lazy(() => import("./components/usuarios/Usuarios"));
const Cobranza = React.lazy(() => import("./components/cobranza"));
const F29 = React.lazy(() => import("./components/f29"));
const _Configuracion = React.lazy(() => import("./components/configuracion/Configuracion"));
const Configuracion2 = React.lazy(() => import("./components/configuracion2"));
const Logout = React.lazy(() => import("./components/login/Logout"));
const _Suscripcion = React.lazy(() => import("./components/suscripcion"));
const Eoaf = React.lazy(() => import("./components/EOAF"));
const Cuadratura = React.lazy(() => import("./components/cuadratura" ))
const CargaArchivos = React.lazy(() => import("./components/cargaArchivos"))
const Softlanding = React.lazy(() => import("./components/softlanding"))
const ReporteVentas = React.lazy(() => import("./components/reporteVentas/ReporteVentas"))
const ReporteCompras = React.lazy(() => import("./components/reporteCompras/ReporteCompras"))
const DeudaProveedores = React.lazy(() => import("./components/dashboard/DeudaProveedores"))
const DeudaClientes = React.lazy(() => import("./components/dashboard/DeudaClientes"))
const PlanDeCuentas = React.lazy(() => import("./components/planDeCuentas/PlanDeCuentas"))
const EstructurasMaestras = React.lazy(() => import("./components/estructurasMaestras/EstructurasMaestras"))
const EstadoResultadosGestion = React.lazy(() => import("./components/reportesGestion/EstadoResultadosGestion"))
const BalanceClasificadoGestion = React.lazy(() => import("./components/reportesGestion/BalanceClasificadoGestion"))
const CentralizacionContable = React.lazy(() => import("./components/centralizacionContable/CentralizacionContable"))
const Balance8Columnas = React.lazy(() => import("./components/balance8Columnas/Balance8Columnas"))
const BalanceClasificado = React.lazy(() => import("./components/balanceClasificado/BalanceClasificado"))
const EstadoResultadosContable = React.lazy(() => import("./components/estadoResultadosContable/EstadoResultadosContable"))
const LibroMayor = React.lazy(() => import("./components/libroMayor/LibroMayor"))
const LibroDocumentosReport = React.lazy(() => import("./components/libroDocumentosReport/LibroDocumentosReport"))
const LibroDiario = React.lazy(() => import("./components/libroDiario/LibroDiario"))
const Asientos = React.lazy(() => import("./components/asientos/Asientos"))
const Auditor = React.lazy(() => import("./components/auditor/Auditor"))
const CierreAperturaContable = React.lazy(() => import("./components/cierreAperturaContable/CierreAperturaContable"))
const Repositorio = React.lazy(() => import("./components/repositorio/Repositorio"))
const ReporteRRHH = React.lazy(() => import("./components/reporteRRHH/ReporteRRHH"))
const HaberesVariables = React.lazy(() => import("./components/haberesVariables/HaberesVariables"))
const CargarNuevoEmpleado = React.lazy(() => import("./components/cargarNuevoEmpleado/CargarNuevoEmpleado"))
const ValidadorLiquidaciones = React.lazy(() => import("./components/validadorLiquidaciones/ValidadorLiquidaciones"))
const ContratosProximosAVencer = React.lazy(() => import("./components/contratosProximosAVencer/ContratosProximosAVencer"))
const AvanceContable = React.lazy(() => import("./components/avanceContable/AvanceContable"))
const WorkerInviteWizard = React.lazy(() => import("./components/cargarNuevoEmpleado/WorkerInviteWizard"))
const EmployerDraftComplete = React.lazy(() => import("./components/cargarNuevoEmpleado/EmployerDraftComplete"))
const CuadreCartolas = React.lazy(() => import("./components/cuadreCartolas/CuadreCartolas"))
const ImpuestosConsolidadoHub = React.lazy(() =>
  import("./components/f29/ImpuestosConsolidadoHub")
);
const RentaConsolidado = React.lazy(() =>
  import("./components/rentaConsolidado/RentaConsolidado")
);
const EstadoDj = React.lazy(() =>
  import("./components/estadoDj/EstadoDj")
);
const Descargas = React.lazy(() => import("./components/descargas/Descargas"));
const TarjetasCredito = React.lazy(() => import("./components/tarjetasCredito/TarjetasCredito"));
const FichaCliente = React.lazy(() => import("./components/fichaCliente"));

function RedirectEstadoObservacionF29() {
  return <Redirect to="/consolidado-f29?tab=estado" />;
}

function RedirectCuadreFormularioF29() {
  return <Redirect to="/consolidado-f29?tab=cuadre" />;
}

const RedirectLibroDocumentosToPersonalizados = () => <Redirect to="/reportes_personalizados" />;

const routes = [
  { path: "/softlanding", name: "Configuración Inicial", component: Softlanding, pageTitle: "Configuración Inicial" },
  { path: "/dashboard", name: "Dashboard", component: Dashboard, pageTitle: "Dashboard" },

  { path: "/reportes_ventas", name: "Reporte de Ventas", component: ReporteVentas, pageTitle: "Reporte de Ventas" },  
  { path: "/reportes_compras", name: "Reporte de Compras", component: ReporteCompras, pageTitle: "Reporte de Compras" },
  { path: "/reportes_cobranza", name: "Reporte de Cobranza", component: DeudaClientes, pageTitle: "Reporte de Cobranza" },
  { path: "/reportes_proveedores", name: "Reporte de Proveedores", component: DeudaProveedores, pageTitle: "Reporte de Proveedores" },


  { path: "/flujo_caja", name: "FlujoCaja", component: FlujoCaja, pageTitle: "Flujo de Caja" },
  { path: "/eerr", name: "Estado de Resultados", component: Eerr, pageTitle: "Estado de Resultados de Gestión" },
  { path: "/plan_de_cuentas", name: "Plan de Cuentas", component: PlanDeCuentas, pageTitle: "Plan de Cuentas" },
  { path: "/estructuras_maestras", name: "Estructuras Maestras", component: EstructurasMaestras, pageTitle: "Estructuras Maestras" },
  { path: "/estado_de_resultados_gestion", name: "Estado de Resultados de Gestión", component: EstadoResultadosGestion, pageTitle: "Estado de Resultados de Gestión" },
  { path: "/balance_clasificado_gestion", name: "Balance Clasificado de Gestión", component: BalanceClasificadoGestion, pageTitle: "Balance Clasificado de Gestión" },
  { path: "/centralizacion_contable", name: "Centralización Contable", component: CentralizacionContable, pageTitle: "Centralización Contable" },
  { path: "/balance_8_columnas", name: "Balance 8 Columnas", component: Balance8Columnas, pageTitle: "Balance 8 Columnas" },
  { path: "/balance_clasificado", name: "Balance Clasificado", component: BalanceClasificado, pageTitle: "Balance Clasificado" },
  { path: "/estado_de_resultados_contable", name: "Estado de Resultados", component: EstadoResultadosContable, pageTitle: "Estado de Resultados" },
  { path: "/libro_mayor", name: "Libro Mayor", component: LibroMayor, pageTitle: "Libro Mayor" },
  {
    path: "/libro_documentos_report",
    exact: true,
    name: "Personalizados",
    component: RedirectLibroDocumentosToPersonalizados,
    pageTitle: "Personalizados",
  },
  { path: "/libro_diario", name: "Libro Diario", component: LibroDiario, pageTitle: "Libro Diario" },
  { path: "/asientos", name: "Asientos", component: Asientos, pageTitle: "Asientos" },
  { path: "/libro-compra-venta", name: "Libro Compra/Venta", component: Auditor, pageTitle: "Libro Compra/Venta" },
  { path: "/cierre_apertura_contable", name: "Cierre / Apertura Contable", component: CierreAperturaContable, pageTitle: "Cierre / Apertura Contable" },
  { path: "/avance_contable", name: "Estado de Avance", component: AvanceContable, pageTitle: "Estado de Avance" },
  { path: "/cuadre_formulario_29", name: "Cuadre Formulario 29", component: RedirectCuadreFormularioF29, pageTitle: "Cuadre Formulario 29" },
  {
    path: "/documentos_tributarios",
    name: "DocumentosTributarios",
    component: DocumentosTributarios,
    pageTitle: "Documentos"
  },
  {
    path: "/boletas",
    name: "Boletas de Honorarios",
    component: DocumentosTributarios,
    pageTitle: "Boletas de Honorarios"
  },
  {
    path: "/obligaciones",
    name: "Obligaciones",
    component: DocumentosTributarios,
    pageTitle: "Obligaciones"
  },
  {
    path: "/cuotas_de_creditos",
    name: "Cuotas de Créditos",
    component: DocumentosTributarios,
    pageTitle: "Cuotas de Créditos",
  },
  {
    path: "/declaraciones_de_ingresos",
    name: "DIN",
    component: DocumentosTributarios,
    pageTitle: "Declaraciones de Ingresos"
  },
  { path: "/creditos", name: "Creditos", component: Creditos, pageTitle: "Préstamos" },
  { path: "/pago_proveedores", name: "Proveedores", component: Proveedores, pageTitle: "Pago a Proveedores" },
  { path: "/cuadratura", name: "Cuadratura", component: Cuadratura, pageTitle: "Cuadratura" },
  { path: "/agenda", name: "Contactos", component: Agenda, pageTitle: "Contactos" },
  { path: "/conciliacion", name: "Conciliación Bancaria", component: Conciliacion2, pageTitle: "Conciliación Bancaria" },
  { path: "/cuadre_cartolas", name: "Cuadre Cartolas", component: CuadreCartolas, pageTitle: "Cuadre de Cartolas Bancarias" },
  { path: "/repositorio/:sectionKey?/:periodKey?/:action?", name: "Repositorio", component: Repositorio, pageTitle: "Repositorio" },
  { path: "/tarjetas_credito/:periodKey?/:action?", name: "Tarjetas de Crédito", component: TarjetasCredito, pageTitle: "" },
  { path: "/ficha_cliente", name: "Ficha Cliente", component: FichaCliente, pageTitle: "Ficha Cliente" },
  { path: "/conexiones", name: "Conexiones", component: Conexiones, pageTitle: "Conexiones" },
  { path: "/descargas", name: "Descargas", component: Descargas, pageTitle: "Descargas" },
  { path: "/reportes", name: "Reportes", component: Reportes, pageTitle: "Reportes" },
  { path: "/reportes_dj", name: "Reportes DJ", component: ReportesDJ, pageTitle: "Reportes DJ" },
  { path: "/reportes_personalizados", name: "Personalizados", component: LibroDocumentosReport, pageTitle: "Personalizados" },
  { path: "/usuarios", name: "Usuarios", component: Usuarios, pageTitle: "Usuarios" },
  { path: "/cobranza", name: "Cobranza", component: Cobranza, pageTitle: "Cobranza" },
  { path: "/formulario-29", name: "Formulario 29", component: F29, pageTitle: "Formulario 29" },
  { path: "/consolidado-f29", name: "Consolidado Formulario 29", component: ImpuestosConsolidadoHub, pageTitle: "Consolidado Formulario 29" },
  { path: "/multas-sii", name: "Multas en el SII", component: ImpuestosConsolidadoHub, pageTitle: "Multas en el SII" },
  { path: "/renta", name: "Declaración de Renta", component: RentaConsolidado, pageTitle: "Declaración de Renta" },
  { path: "/estado_dj", name: "Estado de las Declaraciones Juradas", component: EstadoDj, pageTitle: "Estado de las Declaraciones Juradas" },
  { path: "/estado-observacion", name: "Estado de Observación", component: RedirectEstadoObservacionF29, pageTitle: "Estado de Observación" },
  // { path: "/configuracion", name: "Configuración", component: Configuracion, pageTitle: "Configuración" },
  { path: "/configuracion", name: "Configuración", component: Configuracion2, pageTitle: "Configuración" },
  { path: "/configuracion2", name: "Config 2", component: Configuracion2, pageTitle: "Configuración" },
  { path: "/carga", name: "Carga de Archivos", component: CargaArchivos, pageTitle: "" },
  // { path: "/suscripcion", name: "Suscripción", component: Suscripcion},
  { path: "/logout", name: "Logout", component: Logout },
  { path: "/eoaf", name: "EOAF", component: Eoaf, pageTitle:"Estado de Origen y Aplicación de Fondos" },
  { path: "/reportes_ventas", name: "Reporte de Ventas", component: ReporteVentas, pageTitle: "Reporte de Ventas" },
  { path: "/reportes_compras", name: "Reporte de Compras", component: ReporteCompras, pageTitle: "Reporte de Compras" },
  { path: "/reportes_rrhh", name: "Reporte RRHH", component: ReporteRRHH, pageTitle: "Reporte RRHH" },
  { path: "/haberes_variables", name: "Haberes Variables", component: HaberesVariables, pageTitle: "Haberes Variables" },
  { path: "/validador_liquidaciones", name: "Validador de Liquidaciones", component: ValidadorLiquidaciones, pageTitle: "Validador de Liquidaciones" },
  { path: "/cargar_nuevo_empleado", name: "Cargar Nuevo Trabajador", component: CargarNuevoEmpleado, pageTitle: "Cargar Nuevo Trabajador", exact: true },
  { path: "/contratos_proximos_a_vencer", name: "Contratos Próximos a Vencer", component: ContratosProximosAVencer, pageTitle: "Contratos Próximos a Vencer" },
  { path: "/cargar_nuevo_empleado/invitar/:token", name: "Invitación Trabajador", component: WorkerInviteWizard, pageTitle: "Completar ficha" },
  { path: "/cargar_nuevo_empleado/borrador/:draftId", name: "Completar Borrador", component: EmployerDraftComplete, pageTitle: "Completar ficha" },
];

export default routes;
